import * as React from 'react';
import { memo } from 'react';

import ContentLoader from 'react-content-loader';
import { useWindowSize } from 'services/hooks';
import { CLIENT_WIDTH } from 'services/ui';

export const HeaderPreloader = memo((props) => {
  const { width } = useWindowSize();
  return width && width >= CLIENT_WIDTH.TABLET ? (
    <ContentLoader
      speed={2}
      width={1110}
      height={87}
      viewBox="0 0 1110 87"
      backgroundColor="var(--color-bg-gray)"
      foregroundColor="var(--color-additional-gray)"
      {...props}>
      <rect opacity="0.5" y="28" width="1110" height="1" fill="var(--color-system-gray)" />
      <rect y="47" width="1110" height="40" fill="var(--color-bg-gray)" />
      <rect width="1110" height="18" fill="var(--color-bg-gray)" />
    </ContentLoader>
  ) : (
    <ContentLoader
      speed={2}
      width="100%"
      height={28}
      backgroundColor="var(--color-bg-gray)"
      foregroundColor="var(--color-additional-gray)"
      {...props}>
      <rect width="100%" height="28" fill="var(--color-bg-gray)" />
    </ContentLoader>
  );
});
